import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Col extends Component {
  static propTypes = {
    gutters: PropTypes.bool,
    right: PropTypes.bool,
    flex: PropTypes.string,
    alignSelf: PropTypes.string,
    margin: PropTypes.number,
    children: PropTypes.any
  }

  render() {
    const { children, gutters, margin, flex, right, alignSelf } = this.props
    let textAlign = 'left'

    textAlign = right && 'right'

    return (
      <div
        style={{
          flex: flex && flex,
          textAlign,
          margin: gutters ? `0 ${margin}px` : 0,
          alignSelf: alignSelf || 'initial'
        }}
      >
        {children}
      </div>
    )
  }
}
